import { Box, Theme, Typography } from "@mui/material";
import CustomTable from "../../investorOverview/common/customTable";
import { AssetAllocationGuidelinesHeaderData } from "./tableHeaders";
import { AssetAllocationGuidelinesBody } from "./tableBodies";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAssetAllocationGuidelines } from "../../../redux-store/actions/analytics";
import { AssetAllocationGuidelineRes } from "../../../redux-store/types/analytics";
import { RootStateType } from "../../../redux-store/reducers";
import { ComplianceProps } from "../portfolioAnalytics/compliance";







export default function AssetAllocationGuidelinesTable(props: ComplianceProps): JSX.Element {
    const { clientCode, portfolioId } = props;
    const [assetTableData, setAssetTableData] = useState<AssetAllocationGuidelineRes>({} as AssetAllocationGuidelineRes)
    const [assetAllocLoading, setAssetAllocLoading] = useState<boolean>(false);

    const dispatch = useDispatch();
    const { iwappRmId = "" } = useSelector((state: RootStateType) => state.id);

    const payload = {
        rmId: `${iwappRmId}`,
        clientCode,
        portfolioId,
        assetGroup: null
    }


    useEffect(() => {

        const fetchAssetAllocGuidelineData = async () => {
            try {
                setAssetAllocLoading(true);
                const assetAllocRes = await (dispatch(getAssetAllocationGuidelines(payload)) as unknown as Promise<AssetAllocationGuidelineRes>);
                setAssetTableData(assetAllocRes);
            } catch (e) {
                console.log('E', e);
            } finally {
                setAssetAllocLoading(false)
            }

        }
        fetchAssetAllocGuidelineData();
    }, [])

    if (!assetAllocLoading && !assetTableData?.isSuccess) {
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    position: "relative"
                }}
            >
                <Typography
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        fontWeight: 500,
                        lineHeight: "22.5px",
                        letterSpacing: "0.01px",
                        color: theme.palette.text.primary,
                        textAlign: "center",
                        width: "100%"
                    })}
                >
                    Something went wrong. Please try again.
                </Typography>
            </Box>
        )
    }

    return (
        <Box >
            <CustomTable
                loadingRowsNum={5}
                isLoading={assetAllocLoading}
                tableBody={
                    <AssetAllocationGuidelinesBody
                        tableBodyData={assetTableData?.result || []}
                    />
                }
                tableData={assetTableData?.result || []}
                tableBodyLoaderRowCustomStyles={{
                    '& td:first-of-type': {
                        paddingLeft: "0px"
                    },
                }}
                tableHeaderData={AssetAllocationGuidelinesHeaderData}
                tableHeadRowCustomStyles={{
                    '& th:first-of-type': {
                        paddingLeft: "0px",
                    }
                }}
                handleSort={() => { console.log("SORT") }}
                tableBodyCustomStyles={{
                    '& tr:last-child td': {
                        border: 0
                    }
                }}
                // order={sortingObj.order}
                // orderBy={sortingObj.orderBy}
                tableDataCount={assetTableData?.result?.length}
                isPaginationVisible={false}
            />
        </Box>
    )
}   